<template>
  <page :class="!hasNone ? 'bg-color' : ''">
    <div class="shopping-car-page">
      <div class="has-nothing" v-if="hasNone">
        <div class="nothing">您的购物车还是空空的哦~</div>
        <div class="to-home">
          <van-button @click="toHomePage" class="to-home-btn" type="danger"
            >回首页逛逛</van-button
          >
        </div>
      </div>
      <div class="has-goods" v-else>
        <div class="count">
          <span>已选商品数量：{{ selectCount }}</span>
        </div>
        <ul class="shopping-car-list">
          <li
            class="list-item"
            v-for="(item, index) in shoppingListData"
            :key="index"
          >
            <van-swipe-cell>
              <div class="item-box">
                <van-checkbox
                  v-model="item.isSelect"
                  :value="item.skuId"
                  @click="chooseItem(item)"
                  checked-color="#ee0a24"
                ></van-checkbox>
                <div class="list-detail fl">
                  <div class="shop_img fl">
                    <img :src="item.goods.skuThumb" alt="" />
                  </div>
                  <div class="shop-msg fl">
                    <p class="goods-name ft-12 color-333">
                      {{ item.goodsName }}
                    </p>
                    <p class="goods-price ft-12 color-333">
                      {{ item.goodsPrice }}
                    </p>
                  </div>
                </div>
                <div class="count-step fl">
                  <span
                    class="minus minus-grey"
                    v-if="item.goodsNumber <= 1"
                  ></span>
                  <span
                    class="minus"
                    v-else
                    @click="updateGoodsNum(item, 'minus')"
                  ></span>
                  <van-field
                    class="cc-cart--number"
                    v-model="item.goodsNumber"
                    maxlength="3"
                    @keyup="goodsNumberKeyup(item)"
                    @blur="updateGoodsNum(item, 'input')"
                  />
                  <span
                    class="push"
                    v-if="item.goodsNumber < 999"
                    @click="updateGoodsNum(item, 'push')"
                  ></span>
                  <span class="push minus-grey" v-else></span>
                </div>
              </div>
              <van-button
                slot="right"
                class="del-btn delete-button"
                square
                type="danger"
                @click="handleDelect(item)"
                text="删除"
              />
            </van-swipe-cell>
          </li>
        </ul>
        <div class="submit-bar">
          <van-submit-bar
            :price="total * 100"
            button-text="去结算"
            @submit="onSubmit(total)"
          >
            <van-checkbox
              class=""
              v-model="AllChecked"
              @click="isSelectAll"
              checked-color="#ee0a24"
              >全选</van-checkbox
            >
            <span slot="tip" v-if="tips">
              你的收货地址不支持同城送, <span>修改地址</span>
            </span>
          </van-submit-bar>
        </div>
      </div>
    </div>
  </page>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      hasNone: true, // 是否有购物车商品
      selectCount: null, // 合计数量
      AllChecked: true,
      tips: false,
      total: 0.0, // 合计金额
      selectedIds: [],
      isLogin: true,
      cartsId: [], // 购物车Id集合
      shoppingListData: [],
      skuId: ''
    }
  },
  computed: {
    ...mapGetters(['getEmpNo', 'getFromUrl', 'isFormalEmp']),
    ccLogParams () {
      // 制造一个字段用循环构造数据
      let map = {
        commodity_id: 'skuId',
        commodity_name: 'goodsName',
        goods_price: 'goodsPrice',
        original_price: 'marketPrice',
        commodity_type: 'goodsClassify',
        product_quantity: 'goodsNumber'
      }
      // 需要提交埋点的数据
      let param = {}
      let total = 0
      this.shoppingListData.forEach(item => {
        total += parseInt(item.goodsNumber)
        // 依次记录每个商品的id,名字,金额,种类,数量
        for (let key in map) {
          let name = map[key]
          if (param[key] === undefined) {
            param[key] = ''
          }
          param[key] = `${param[key]}${item[name]},`
        }
      })
      // param里每个字段最后都是个逗号,需要-1处理
      for (let key in map) {
        if (param[key] === undefined) {
          continue
        }
        param[key] = param[key].substr(0, param[key].length - 1)
      }
      return {
        ...param,
        // user_type: this.isFormalEmp,
        user_empNo: this.getEmpNo || '',
        frontPageName: this.getFromUrl,
        total_price_of_commodity: this.total,
        total_number_of_commodity: total,
        page_name: '购物车'
      }
    }
  },
  methods: {
    ...mapMutations(['pushPageList']),
    handleDelect (item) {
      this.$service.deleteGoodsNew({ goodsIds: [item.skuId] }).then(res => {
        this.$toast('删除成功！')
        this.queryCarList()
      })
    },
    // 提交订单
    onSubmit () {
      let goodIds = []
      this.shoppingListData.forEach(item => {
        if (item.isSelect === true) {
          goodIds.push(item.skuId)
        }
      })
      if (goodIds.length === 0) {
        return this.$toast('请至少选一件商品结算')
      }
      let params = {}
      // params.number = this.shoppingListData[0].goodsNumber
      params.goodsId = goodIds.toString()
      params.buyType = 1 // 购物车渠道结算
      this.pushPageList('去结算')
      this.$constants.submitccLog(
        'partner_mini_page_click',
        '购物车点击去结算',
        {
          ...this.ccLogParams,
          button_name: '去结算'
        }
      )
      this.$router.push({ name: 'paying', query: params })
    },
    // 单选
    chooseItem (item) {
      console.log(item)
      this.updateGoodsSelect([item.skuId], item.isSelect)
    },
    updateGoodsSelect (goodsIds, isSelect) {
      this.$service
        .updateGoodsSelectNew({
          goodsIds: goodsIds,
          select: isSelect ? 1 : 0 // 选中为1，为选中 0
        })
        .then(res => {
          this.queryCarList()
        })
    },
    // 更新购物数量加减
    updateGoodsNum (item, type) {
      let num = parseInt(item.goodsNumber)
      const goodsNumber =
        type === 'push' ? num + 1 : type === 'minus' ? num - 1 : num || 1
      this.$service
        .updateGoodsNumNew({
          goodsId: item.skuId,
          num: goodsNumber
        })
        .then(res => {
          this.queryCarList()
          // item.goodsNumber = goodsNumber
        })
    },
    // goodsNumberKeyup
    goodsNumberKeyup (item) {
      // const data = JSON.parse(JSON.stringify(item))
      // console.log(data.goodsNumber.toString())
      item.goodsNumber = item.goodsNumber.toString().replace(/[^\d.]/g, '')
    },

    queryCarList () {
      // let self = this
      this.$service.getCartListNew().then(async res => {
        const data = res.data
        if (data.cartList.length !== 0) {
          this.hasNone = false
          this.selectCount = parseInt(data.selectCount)
          this.total = data.selectTotalMoney
          this.AllChecked = data.selectCount === data.totalCount
          this.shoppingListData = data.cartList.map(item => {
            if (item['isSelect'] === 1) {
              item['isSelect'] = true
            } else {
              item['isSelect'] = false
            }
            return item
          })
        } else {
          this.hasNone = true
        }
        this.$constants.submitccLog(
          'partner_mini_page_show',
          '购物车页面曝光',
          {
            ...this.ccLogParams,
            button_name: ''
          }
        )
      })
    },

    toHomePage () {
      this.$router.push({ name: 'store-home' })
    },
    isSelectAll () {
      const goodsid = this.shoppingListData.map(item => item.skuId)
      if (this.AllChecked) {
        this.updateGoodsSelect(goodsid, 1)
      } else {
        this.updateGoodsSelect(goodsid, 0)
      }
    }
  },
  created () {
    this.queryCarList()
  },
  watch: {
    selectCount (val, oldVal) {
      // console.log('我变化了', val, oldVal)
    }
  }
}
</script>
<style lang="stylus" scoped>
p
  margin 0
  padding 0
.shopping-car-page
  width 100%
  padding-bottom 118px
.has-nothing
  padding-top 90px
.nothing
  text-align center
  width 300px
  height 300px
  margin 30% auto 0
  font-size 14px
  color: #333
  vertical-align middle
.to-home
  position fixed
  bottom 116px
  width 100%
  text-align center
.to-home-btn
  width 335px
  border-radius 8px 8px
.has-goods .shopping-car-list
  // background #fff
  overflow hidden
  min-height 300px
.shopping-car-list .list-item
  height 101px
  width 375px
  clear both
  border-bottom 1px solid #EFEFF4
  background #fff
.list-item .item-box
  height 61px
  padding 20px 0px
  position relative
.list-item .list-detail
  // width 203px
  // width 375px
.list-detail .shop_img
  width 60px
  height 60px
.shop_img img
  object-fit contain
  width 100%
  height 100%
.list-detail .shop-msg
  margin-left 15px
  width 240px
.shop-msg .goods-price
  margin-top 20px
.list-item .van-checkbox
  width 20px
  padding 0px 10px 0 15px
  float left
  margin-top 20px
.count
  height 44px
  line-height 44px
  padding 0 15px
  background #fff
  border-bottom 1px solid #EFEFF4
.count span
  font-size 14px
  color #333
  float left
.count .edit
  font-size 14px
  color #333
  float right
  border none
  background none
.van-submit-bar
  bottom 61px
.submit-bar .van-checkbox
  margin-left 15px
.icon-checked
  width 30px
  margin-top 20px
.count-step
  position absolute
  right 15px
  bottom 15px
  // margin 30px 0 0 0px
.count-step .minus,
.count-step .push
  width 26px
  height 25px
  display block
  float left
  position relative
  border solid 1px #333
.count-step .minus
  border-right 0 none
  border-radius 3px 0 0 3px
.count-step .push
  border-left 0 none
  border-radius 0 3px 3px 0
.count-step .minus:after,
.count-step .push:after,
.count-step .push:before
  background #333
  position absolute
  content ''
.count-step .minus:after,
.count-step .push:after
  width 14px
  height 1px
  left 6px
  top 12px
.count-step .push:before
  width 1px
  height 14px
  top 6px
  left 13px
.count-step .minus-grey
  border-color #ccc
.count-step .minus-grey:after,
.count-step .minus-grey:before
  background #ccc

.cc-cart--number
  padding 0
  border 1px solid #333
  float left
  width 42px
  height 27px
.cc-cart--number >>>.van-field__control
  line-height 25px
  text-align center

.cell
  overflow hidden
  display flex
  border-bottom 1px solid #EFEFF4
.cell .cell-info
  width 100%
  flex-shrink 0
.cell .cell-delect
  width 60px
  background #FC4C00
  color #ffffff
  font-size 14px
  line-height 90px
  height 90px
.van-swipe-cell__wrapper .van-swipe-cell__right
  height 100px
  background #cdcdcd
.del-btn
  background red
  text-align center
  height 100%
</style>
